<template>
  <suspense>
    <ContentfulRichText
      v-if="data"
      :content="data.content"
      :class="classes"
      :spacing-rule="data.spacingRule"
      :typography-rule="data.typeRule"
      :align="data.align"
      :body-color="data.fontColor"
      :heading-color="data.fontColorHeading"
      :background-color="data.backgroundColor"
      :typography-width-rule="data.maxWidth"
      :link-color="data.linkColor"
      :link-decoration="data.linkDecoration"
    />
  </suspense>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import { computed, defineAsyncComponent } from 'vue';

export default {
  components: {
    ContentfulRichText: defineAsyncComponent(() => import('../Fields/ContentfulRichText.vue')),
  },
  props: contentfulProps,
  async setup(p, c) {
    const { data, init } = useContentful('pageComponentSection', p, c);

    const classes = computed(() => {
      if (!data.value) {
        return '';
      }
      const c = ['cf-richtext-section'];
      if (data.value.fullWidth) c.push('bleedout');
      return c;
    });

    await init();
    return { data, classes };
  },
};
</script>
//
<style lang="postcss">
@import '@/pixel/style/variables';
</style>
